const initialState = {
  reservationDetails: {
    pickupLocation: "",
    pickupDate: null,
    returnDate: null,
  },
  tempBookingDetails: {
    carId: null,
    pickupLocation: "",
    pickupDate: null,
    returnDate: null,
    pickupTime: null,
    returnTime: null,
    extraService: false,
    depositOption: "full",
  },
};

export default initialState;
